import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { animated, useTransition } from '@react-spring/web';
import { Box } from '../Box/index.js';

/// /////////////////////////////////////////////////////////////////////
const StyledOverlay = _ref => {
  let {
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    bg: "overlay",
    bottom: "0",
    left: "0",
    position: "fixed",
    right: "0",
    top: "0",
    zIndex: "overlay",
    onClick: e => {
      e.stopPropagation();
    }
  }, rest));
};
const AnimatedOverlay = animated(StyledOverlay);
/// /////////////////////////////////////////////////////////////////////
// Easing function from d3-ease: https://github.com/d3/d3-ease/blob/master/src/exp.js
function expOut(t) {
  // ! Do not change this. ESlint broke it
  // eslint-disable-next-line
  return 1 - Math.pow(2, -10 * t);
}
// Currently only supports *Modal and *Drawer*
const Fade = _ref2 => {
  let {
    isOpen,
    children,
    duration = 200,
    ...rest
  } = _ref2;
  const transitions = useTransition(isOpen, {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    },
    config: {
      duration
    }
  });
  return transitions((styles, item) => item && /*#__PURE__*/React__default.createElement(AnimatedOverlay, _extends({
    style: {
      opacity: styles.opacity
    }
  }, rest), children));
};
// Currently only supports *Drawer*
// If we need dynamic slide animations, we need to adjust for placement
const Slide = _ref3 => {
  let {
    isOpen,
    children,
    duration = 300,
    from = 'right',
    maxWidth = 504
  } = _ref3;
  const placements = {
    left: {
      left: 0
    },
    right: {
      right: 0
    }
  };
  const transitionOptions = {
    left: {
      left: 0,
      transform: x => `translateX(-${x}%)`
    },
    right: {
      right: 0,
      transform: x => `translateX(${x}%)`
    }
  };
  const {
    transform
  } = transitionOptions[from];
  const transitions = useTransition(isOpen, {
    from: {
      transform: transform(100)
    },
    enter: {
      transform: transform(0)
    },
    leave: {
      transform: transform(100)
    },
    config: {
      duration,
      easing: expOut
    }
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, transitions((styles, item) => item && /*#__PURE__*/React__default.createElement(animated.div, {
    style: {
      transform: styles.transform,
      // Overrides Drawer-extended styles
      position: 'fixed',
      maxWidth,
      width: '100%',
      top: 0,
      bottom: 0,
      padding: 0,
      margin: 0,
      zIndex: 140,
      ...placements[from]
    }
  }, children)));
};

export { Fade, Slide };
